import { isMemberAdmin } from './memberships';
import { Member, Board, Workspace } from './types';

export const canDeleteBoard = (
  member: Member,
  board: Board,
  workspace?: Workspace,
): boolean => {
  if (!board) {
    return false;
  }

  const isAdmin = isMemberAdmin(member, board);
  if (!isAdmin) {
    return false;
  }

  if (!workspace) {
    return true;
  }

  const workspaceDeleteRestrictions = workspace?.prefs?.boardDeleteRestrict;
  if (!workspaceDeleteRestrictions) {
    return true;
  }

  const boardPermission = board?.prefs?.permissionLevel;
  if (!boardPermission) {
    return true;
  }

  const workspaceDeleteRestriction =
    workspaceDeleteRestrictions[boardPermission];

  switch (workspaceDeleteRestriction) {
    case 'org':
      return true;

    case 'admin': {
      const isWorkspaceAdmin = (workspace?.memberships || []).some(
        ({ idMember, memberType }) => {
          return idMember === member.id && memberType === 'admin';
        },
      );

      if (isWorkspaceAdmin) {
        return true;
      }

      return false;
    }

    default:
      return false;
  }
};
